import { del, get, jsonParser, post, put } from "./Client";


export const getStyle = (style) => 
  get(`/styles/${style.id}`).then(jsonParser);

export const searchStyle = (query, all = false, page = 0, sort = "createdDate", order = "ASC") =>
  get(`/styles?query=${query}&all=${all ? "true" : "false"}&page=${page}&sort=${sort}&order=${order}`)
  .then(jsonParser);

export const createStyle = (style) =>
  post("/styles", { body: style }).then(jsonParser);

export const updateStyle = (style) =>
  put(`/styles/${style.id}`, { body: style }).then(jsonParser);

export const deleteStyle = (style) => 
  del(`/styles/${style.id}`).then(jsonParser);
